import { useContext, useState } from "react";
import { Alert, Button, Form, Modal, Tooltip } from "antd";
import { Patient } from "./interfaces";
import {
  ALMSG_INTERNAL_ERR,
  DEL_SUCCESS,
  HOME_PATH,
  PATIENTS_PATH,
} from "../env";
import { deletePatient } from "./utils";
import { SignedInDoctor } from "../auth/interfaces";
import { SignedInContext } from "../AppEnv";
import { useNavigate } from "react-router-dom";
import { MENU_KEYS } from "../LoggedInWrapper";

const DeletePatientModal = ({ patient }: { patient: Patient }) => {
  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;
  const [visible, setVisible] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [form] = Form.useForm();

  const navigate = useNavigate();

  //submit data
  const onFinish = () => {
    deletePatient(signedInDoctor, patient)
      .then((patientOpString: string) => {
        try {
          const pId: number = parseInt(JSON.parse(patientOpString).id);
          if (!isNaN(pId) && pId == patient.id) {
            navigate(
              "/app" + HOME_PATH + PATIENTS_PATH + "?" + DEL_SUCCESS + "=1"
            );
          } else setErrMsg(ALMSG_INTERNAL_ERR);
        } catch {
          setErrMsg(ALMSG_INTERNAL_ERR);
        }
      })
      .catch(() => setErrMsg(ALMSG_INTERNAL_ERR));
  };

  return (
    <>
      <Button
        className="ant-btn-danger"
        onClick={() => setVisible(true)}
        style={{
          background: "red",
          color: "white",
          margin: "2px",
        }}
      >
        ELIMINA
      </Button>
      <Modal
        title="Elimina dati paziente"
        centered
        open={visible}
        footer={false}
        onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
        width={480}
      >
        <Form
          form={form}
          name="control-hooks"
          onFinish={onFinish}
          layout="vertical"
        >
          <Form.Item>
            Sei sicuro di voler eliminare tutti i dati relativi all'anagrafica e
            agli esami svolti da {patient.name} {patient.surname}?
          </Form.Item>

          {errMsg && (
            <Form.Item>
              <Alert
                message={ALMSG_INTERNAL_ERR}
                description="Cancellazione non riuscita"
                type="error"
                showIcon
              />
            </Form.Item>
          )}
          <Form.Item style={{ margin: "auto", textAlign: "right" }}>
            <Tooltip
              placement="top"
              title={
                "Attento!! Operazione irreversibile: perderai tutti i dati del paziente"
              }
            >
              <Button
                className="ant-btn-ghost"
                type="dashed"
                htmlType="submit"
                style={{
                  background: "black",
                  color: "white",
                  margin: "2px",
                }}
              >
                CONFERMA
              </Button>
            </Tooltip>
            <Button
              className="ant-btn-danger"
              type="primary"
              onClick={() => setVisible(false)}
            >
              ANNULLA
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default DeletePatientModal;
